module.exports = __webpack_public_path__ + "img/map-pattern-a.80e409e3.png";